// Generated from the Bootstrap icon names used in src.
// Keep this registry explicit so webpack can tree-shake unused Lucide icons.
import {
  Activity,
  AlignCenter,
  AlignLeft,
  AlignRight,
  AppWindow,
  Apple,
  Archive,
  ArrowDown,
  ArrowDownUp,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  Banknote,
  Barcode,
  Bell,
  Bold,
  BookCheck,
  Bot,
  Box,
  BoxSelect,
  Boxes,
  Braces,
  Briefcase,
  BriefcaseBusiness,
  Building2,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarCheck2,
  CalendarDays,
  CalendarRange,
  CalendarX,
  Camera,
  ChartNoAxesColumn,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartPie,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleArrowDown,
  CircleArrowOutDownLeft,
  CircleArrowOutUpRight,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleHelp,
  CircleMinus,
  CirclePlay,
  CirclePlus,
  CircleSlash,
  CircleUserRound,
  CircleX,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  ClipboardX,
  Clock,
  CloudCheck,
  CloudDownload,
  CloudOff,
  CloudUpload,
  CodeSquare,
  CodeXml,
  Coins,
  Contact,
  ContactRound,
  Copy,
  CreditCard,
  DollarSign,
  DoorClosed,
  DoorOpen,
  Dot,
  Download,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileArchive,
  FileChartColumn,
  FileCheck2,
  FileImage,
  FilePlus2,
  FileSpreadsheet,
  FileText,
  FileType2,
  FileUp,
  Files,
  Folder,
  FolderPlus,
  Fullscreen,
  Funnel,
  Gauge,
  Gem,
  Globe,
  Grid,
  Grid3X3,
  GripVertical,
  HardDrive,
  Hash,
  Heading,
  Heading1,
  Headset,
  History,
  Hourglass,
  House,
  Image,
  Inbox,
  Info,
  Kanban,
  Key,
  Landmark,
  Languages,
  Laptop,
  Layers,
  Layers3,
  Lightbulb,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  ListTodo,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailOpen,
  MapPin,
  Maximize2,
  Megaphone,
  MessageCircle,
  MessageCircleHeart,
  MessageCircleMore,
  MessageSquareMore,
  MessageSquareQuote,
  MessageSquareText,
  Minimize,
  Minimize2,
  Minus,
  Moon,
  Network,
  NotebookText,
  OctagonAlert,
  OctagonX,
  Package,
  PackageCheck,
  PaintBucket,
  PanelBottom,
  PanelLeftClose,
  PanelRight,
  PanelsTopLeft,
  Paperclip,
  Pause,
  Pen,
  Pencil,
  Percent,
  Phone,
  Pilcrow,
  Play,
  PlayCircle,
  Plug,
  Plus,
  Printer,
  QrCode,
  Ratio,
  ReceiptText,
  Redo2,
  RefreshCw,
  Regex,
  Reply,
  Rocket,
  Save,
  ScanBarcode,
  Search,
  Send,
  Settings,
  Sheet,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Snowflake,
  Square,
  SquareCheckBig,
  SquarePen,
  Star,
  Stars,
  StickyNote,
  Store,
  Sun,
  Sunrise,
  Table,
  Tag,
  Tags,
  ToggleLeft,
  ToggleRight,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Truck,
  Type,
  Undo2,
  Upload,
  UserCheck,
  UserPlus,
  UserRound,
  Users,
  WalletCards,
  WandSparkles,
  Wrench,
  X,
  Youtube,
  Zap,
} from 'lucide-vue'

export default {
  Activity,
  AlignCenter,
  AlignLeft,
  AlignRight,
  AppWindow,
  Apple,
  Archive,
  ArrowDown,
  ArrowDownUp,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  Banknote,
  Barcode,
  Bell,
  Bold,
  BookCheck,
  Bot,
  Box,
  BoxSelect,
  Boxes,
  Braces,
  Briefcase,
  BriefcaseBusiness,
  Building2,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarCheck2,
  CalendarDays,
  CalendarRange,
  CalendarX,
  Camera,
  ChartNoAxesColumn,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartPie,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleAlert,
  CircleArrowDown,
  CircleArrowOutDownLeft,
  CircleArrowOutUpRight,
  CircleArrowUp,
  CircleCheck,
  CircleCheckBig,
  CircleHelp,
  CircleMinus,
  CirclePlay,
  CirclePlus,
  CircleSlash,
  CircleUserRound,
  CircleX,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  ClipboardX,
  Clock,
  CloudCheck,
  CloudDownload,
  CloudOff,
  CloudUpload,
  CodeSquare,
  CodeXml,
  Coins,
  Contact,
  ContactRound,
  Copy,
  CreditCard,
  DollarSign,
  DoorClosed,
  DoorOpen,
  Dot,
  Download,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileArchive,
  FileChartColumn,
  FileCheck2,
  FileImage,
  FilePlus2,
  FileSpreadsheet,
  FileText,
  FileType2,
  FileUp,
  Files,
  Folder,
  FolderPlus,
  Fullscreen,
  Funnel,
  Gauge,
  Gem,
  Globe,
  Grid,
  Grid3X3,
  GripVertical,
  HardDrive,
  Hash,
  Heading,
  Heading1,
  Headset,
  History,
  Hourglass,
  House,
  Image,
  Inbox,
  Info,
  Kanban,
  Key,
  Landmark,
  Languages,
  Laptop,
  Layers,
  Layers3,
  Lightbulb,
  Link2,
  List,
  ListChecks,
  ListFilter,
  ListOrdered,
  ListTodo,
  Lock,
  LockOpen,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailOpen,
  MapPin,
  Maximize2,
  Megaphone,
  MessageCircle,
  MessageCircleHeart,
  MessageCircleMore,
  MessageSquareMore,
  MessageSquareQuote,
  MessageSquareText,
  Minimize,
  Minimize2,
  Minus,
  Moon,
  Network,
  NotebookText,
  OctagonAlert,
  OctagonX,
  Package,
  PackageCheck,
  PaintBucket,
  PanelBottom,
  PanelLeftClose,
  PanelRight,
  PanelsTopLeft,
  Paperclip,
  Pause,
  Pen,
  Pencil,
  Percent,
  Phone,
  Pilcrow,
  Play,
  PlayCircle,
  Plug,
  Plus,
  Printer,
  QrCode,
  Ratio,
  ReceiptText,
  Redo2,
  RefreshCw,
  Regex,
  Reply,
  Rocket,
  Save,
  ScanBarcode,
  Search,
  Send,
  Settings,
  Sheet,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Signpost,
  SlidersHorizontal,
  Smartphone,
  Snowflake,
  Square,
  SquareCheckBig,
  SquarePen,
  Star,
  Stars,
  StickyNote,
  Store,
  Sun,
  Sunrise,
  Table,
  Tag,
  Tags,
  ToggleLeft,
  ToggleRight,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Truck,
  Type,
  Undo2,
  Upload,
  UserCheck,
  UserPlus,
  UserRound,
  Users,
  WalletCards,
  WandSparkles,
  Wrench,
  X,
  Youtube,
  Zap,
}
